export default __webpack_public_path__ + "static/media/svg-1.b08392bf.svg";